import config from '../config.json';
export default (...output) => {
  if (config.env.indexOf('dev') !== -1 || config.env.indexOf('docker') !== -1) {
    output.forEach(item => {
      /* eslint-disable no-console */
      console.log(item);
      /* eslint-enable no-console */
    });
  }
};